import { $fetch } from '@/boot/fetch'
import PaymentMethods from './users/userPaymentMethods'
import Returns from './users/userReturns'
import WatchlistItems from './users/userWatchlistItems'

/**
 * User API
 * @category PegApi
 * @module PegApi.Users
 * @description API for user-related operations
 * @requires module:api/peg/watchlistItems
 */

const ENDPOINT = '/users'

export default {
  PaymentMethods,
  Returns,
  WatchlistItems,
  /**
   * Create a new user
   * @param {object} data - User data
   * @param {string} data.firstName - First name of the user
   * @param {string} data.lastName - Last name of the user
   * @param {string} data.email - Email of the user
   * @param {string} data.phone - Phone number of the user
   * @returns {Promise}
   */
  create(data) {
    return $fetch.peg(ENDPOINT, {
      method: 'POST',
      body: data,
    })
  },
  /**
   * Get user details - utilized auth token in request header to find user
   * @returns {Promise}
   */
  async get() {
    try {
      return await $fetch.peg(ENDPOINT)
    } catch (error) {
      // treat 404 as a successful response to ensure a new user gets created in session.store.js
      if (error?.statusCode === 404) {
        return { success: true, user: null }
      }
      throw error
    }
  },
  /**
   * Update user details
   * @param {object} data - User data
   * @returns {Promise}
   */
  update(data) {
    return $fetch.peg(ENDPOINT, {
      method: 'PUT',
      body: data,
    })
  },
}
